import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react'; // import { Router as NativeRouter } from './bridge.js';
// Const

var rootTagKey = '__rootTag_do_not_change_or_you_will_be_fired';
var TRUE = true,
    FALSE = false,
    NULL = null,
    UNDEFINED = void 0;
var __object__ = Object.prototype,
    __array__ = Array.prototype,
    toString = __object__.toString,
    slice = __array__.slice; // Variable

var defaults = {
  appName: 'naive',
  globalPlugins: [],
  navBar: {
    isShow: false
  }
};
var plugins = {};
var viewMap = {};
var initFns = [];
var registerCallbacks = [];
var Ext = {
  defaults: defaults
};
var cache = {}; // Util

var class2type = {
  '[object HTMLDocument]': 'Document',
  '[object HTMLCollection]': 'NodeList',
  '[object StaticNodeList]': 'NodeList',
  '[object IXMLDOMNodeList]': 'NodeList',
  '[object DOMWindow]': 'Window',
  '[object global]': 'Window',
  'null': 'Null',
  'NaN': 'NaN',
  'undefined': 'Undefined'
};
'Boolean,Number,String,Function,Array,Date,RegExp,Window,Document,Arguments,NodeList,Null,Undefined'.replace(/\w+/ig, function (value) {
  return class2type["[object ".concat(value, "]")] = value;
});

var getType = function getType(obj, match) {
  var rs = class2type[obj === NULL || obj !== obj ? obj : toString.call(obj)] || obj && obj.nodeName || '#';

  if (obj === UNDEFINED) {
    rs = 'Undefined';
  } else if (rs.charAt(0) === '#') {
    if (obj == obj.document && obj.document != obj) {
      rs = 'Window';
    } else if (obj.nodeType === 9) {
      rs = 'Document';
    } else if (obj.callee) {
      rs = 'Arguments';
    } else if (isFinite(obj.size || obj.length) && obj.item) {
      rs = 'NodeList';
    } else {
      rs = toString.call(obj).slice(8, -1);
    }
  }

  if (match) {
    return match === rs;
  }

  return rs;
};

var _isObject = function _isObject(source) {
  return getType(source, 'Object');
};

var _isArray = function _isArray(source) {
  return getType(source, 'Array');
};

var _isString = function _isString(source) {
  return getType(source, 'String');
};

var _isFunction = function _isFunction(source) {
  return getType(source, 'Function');
};

var _isNumber = function _isNumber(source) {
  return getType(source, 'Number');
};

var _isPlainObject = function _isPlainObject(source) {
  return getType(source, 'Object') && Object.getPrototypeOf(source) === __object__;
};

var _isEmptyObject = function _isEmptyObject(source) {
  try {
    return JSON.stringify(source) === "{}";
  } catch (e) {
    return FALSE;
  }
};

var _noop = function _noop() {};

var _sliceFn = function _sliceFn(obj, attr, fn) {
  var originFn = obj[attr];

  obj[attr] = function () {
    fn.apply(this, arguments);

    if (_isFunction(originFn)) {
      return originFn.apply(this, arguments);
    }
  };
};

var extend = function extend(target, source, deep) {
  for (var key in source) {
    if (deep && (_isPlainObject(source[key]) || _isArray(source[key]))) {
      if (_isPlainObject(source[key]) && !_isPlainObject(target[key])) {
        target[key] = {};
      }

      if (_isArray(source[key]) && !_isArray(target[key])) {
        target[key] = [];
      }

      extend(target[key], source[key], deep);
    } else if (source[key] !== UNDEFINED) {
      target[key] = source[key];
    }
  }
};

var _extend = function _extend() {
  var deep,
      args = _makeArray(arguments),
      target = args.shift();

  if (typeof target == 'boolean') {
    deep = target;
    target = args.shift();
  }

  args.forEach(function (arg) {
    return extend(target, arg, deep);
  });
  return target;
};

var _startWith = function _startWith(str, sch) {
  return str.indexOf(sch) == 0;
};

var _endWith = function _endWith(str, sch) {
  return str.indexOf(sch) > -1 && str.indexOf(sch) == str.length - sch.length;
}; // CustEvent


var _once = function _once(func) {
  var ran = FALSE,
      memo;
  return function () {
    if (ran) return memo;
    ran = TRUE;
    memo = func.apply(this, arguments);
    func = NULL;
    return memo;
  };
};

var triggerEvents = function triggerEvents(events, args) {
  var ev,
      i = -1,
      l = events.length,
      ret = 1;

  while (++i < l && ret) {
    ev = events[i];
    ret &= ev.callback.apply(ev.ctx, args) !== FALSE;
  }

  return !!ret;
};

var CustEvent = {
  on: function on(name, callback, context) {
    this._events = this._events || {};
    this._events[name] = this._events[name] || [];
    var events = this._events[name];
    events.push({
      callback: callback,
      context: context,
      ctx: context || this
    });
    return this;
  },
  once: function once(name, callback, context) {
    var self = this;

    var once = _once(function () {
      self.off(name, once);
      callback.apply(self, arguments);
    });

    once._callback = callback;
    return this.on(name, once, context);
  },
  off: function off(name, callback, context) {
    var retain, ev, events, names, i, l, j, k;

    if (!name && !callback && !context) {
      this._events = UNDEFINED;
      return this;
    }

    names = name ? [name] : keys(this._events);

    for (i = 0, l = names.length; i < l; i++) {
      name = names[i];
      events = this._events[name];

      if (events) {
        this._events[name] = retain = [];

        if (callback || context) {
          for (j = 0, k = events.length; j < k; j++) {
            ev = events[j];

            if (callback && callback !== ev.callback && callback !== ev.callback._callback || context && context !== ev.context) {
              retain.push(ev);
            }
          }
        }

        if (!retain.length) delete this._events[name];
      }
    }

    return this;
  },
  trigger: function trigger(name) {
    if (!this._events) return this;
    var args = slice.call(arguments, 1),
        events = this._events[name],
        allEvents = this._events.all,
        ret = 1;

    if (events) {
      ret &= triggerEvents(events, args);
    }

    if (allEvents && ret) {
      ret &= triggerEvents(allEvents, args);
    }

    return !!ret;
  }
};

var _createEventManager = function _createEventManager() {
  var EM = function EM() {};

  _extend(EM.prototype, CustEvent);

  return new EM();
};

var _makeArray = function _makeArray(iterable) {
  if (!iterable) return FALSE;
  var n = iterable.length;

  if (n === n >>> 0) {
    try {
      return slice.call(iterable);
    } catch (e) {}
  }

  return FALSE;
}; // createClass
//去掉componentWillMount，componentWillReceiveProps，componentWillUpdate


var LifeCycles = ["componentDidMount", "componentWillUnmount", "shouldComponentUpdate", "componentDidUpdate"],
    EventsFns = ['on', 'off', 'once', 'trigger'];

var fixedKey = function fixedKey(prefix, key) {
  return prefix + key.replace(/\w/, function (a) {
    return a.toUpperCase();
  });
};

var mergeEventFn = function mergeEventFn(em, obj) {
  EventsFns.forEach(function (key) {
    obj[key] = em[key].bind(em);
  });
  return obj;
};

var WEBX = 'webx';

var fixedLogic = function fixedLogic(context, em, React, isView) {
  defaults.globalPlugins.concat(context.plugins || []).concat(context.constructor.plugins).filter(function (key, index, source) {
    return key && key[0] != '-' && source.indexOf("-".concat(key)) == -1 && source.indexOf(key) == index;
  }).forEach(function (name) {
    if (!_isFunction(plugins[name]) || name === WEBX) return;
    plugins[name].call(em, context, context.constructor["".concat(name, "Plugin")] || {}, React, isView);
  });
  LifeCycles.forEach(function (key) {
    var originFn = context[key];

    context[key] = function () {
      var rs = key.indexOf('should') == 0 ? TRUE : NULL;
      em.trigger.apply(em, [fixedKey('before', key), this].concat(_makeArray(arguments)));

      if (_isFunction(originFn)) {
        try {
          rs = originFn.apply(this, arguments);
        } catch (e) {
          console.log('[QRN-Ext Error]', e);
          throw e;
        }
      }

      em.trigger.apply(em, [fixedKey('after', key), this, rs].concat(_makeArray(arguments)));
      return rs;
    };
  });
  var bindEvents = context.bindEvents || {};

  for (var key in bindEvents) {
    if (_isFunction(bindEvents[key])) {
      em.on(key, bindEvents[key].bind(context));
    }
  }
};

var hookRender = function hookRender(context, em, React, isView) {
  var renderFn = context.render;
  var needInitWebXPlugin = true;
  var hasWebXPlugin = defaults.globalPlugins.concat(context.plugins || []).concat(context.constructor.plugins).filter(function (key, index, source) {
    return key && key[0] != '-' && source.indexOf("-".concat(key)) == -1 && source.indexOf(key) == index;
  }).indexOf(WEBX) > -1;

  context.render = function () {
    var rs = NULL; //render前加载webx plugin

    if (needInitWebXPlugin && hasWebXPlugin) {
      plugins[WEBX].call(em, context, context.constructor["".concat(WEBX, "Plugin")] || {}, React, isView);
      needInitWebXPlugin = false;
    }

    em.trigger.apply(em, ['beforeRender', this].concat(_makeArray(arguments)));

    if (_isFunction(renderFn)) {
      try {
        rs = renderFn.apply(this, arguments);
      } catch (e) {
        console.log('[QRN-Ext Error]', e);
        throw e;
      }
    }

    em.trigger.apply(em, ['afterRender', this, rs].concat(_makeArray(arguments)));
    return rs;
  };
};

var createComponent = function createComponent(React, isView) {
  var ExtComp = /*#__PURE__*/function (_React$Component) {
    _inherits(ExtComp, _React$Component);

    var _super = _createSuper(ExtComp);

    function ExtComp(props, context) {
      var _this;

      _classCallCheck(this, ExtComp);

      var em = _createEventManager();

      _this = _super.call(this, props, context);
      hookRender(_assertThisInitialized(_this), em, React, isView);
      var originFn = _this.componentDidMount;

      _this.componentDidMount = function () {
        // this.name = isView ? this.constructor.name : NULL;
        fixedLogic(this, em, React, isView);
        var rs = null;
        em.trigger.apply(em, ['beforeComponentDidMount', this].concat(_makeArray(arguments)));

        if (_isFunction(originFn)) {
          try {
            rs = originFn.apply(this, arguments);
          } catch (e) {
            console.log('[QRN-Ext Error]', e);
            throw e;
          }
        }

        em.trigger.apply(em, ['afterComponentDidMount', this, rs].concat(_makeArray(arguments)));
      };

      return _this;
    }
    /**
     * 给当前页面设置别名
     * @param {string} name 别名
     * @return {boolean} 是否设置成功
     */


    _createClass(ExtComp, [{
      key: "setView",
      value: function setView(name) {
        var _Ext$Router = Ext.Router,
            hasAllocatedRootTagMap = _Ext$Router._hasAllocatedRootTagMap,
            lifecycleListeners = _Ext$Router._lifecycleListeners,
            hasInvokedSetViewNameKey = _Ext$Router._hasInvokedSetViewNameKey; // 当前页面分配的 rootTag

        var rootTag = this.props[rootTagKey];

        if (!hasAllocatedRootTagMap[rootTag]) {
          // 只能给已经打开过的页面设置，即能到当前页面的 rootTag
          return false;
        } // 当前页面名字


        var prevName = hasAllocatedRootTagMap[rootTag]; // NativeRouter.setViewName(rootTag, name);

        hasAllocatedRootTagMap[rootTag] = name; // 保留改后的 viewKey -> prevKey 的引用

        var viewKey = "".concat(name, "_").concat(rootTag);
        var prevKey = "".concat(prevName, "_").concat(rootTag);
        hasInvokedSetViewNameKey[viewKey] = prevKey; // 保证改后别名的页面的生命周期正常执行

        lifecycleListeners = _objectSpread(_objectSpread({}, lifecycleListeners), {}, _defineProperty({}, viewKey, lifecycleListeners[prevKey]));
        delete lifecycleListeners[prevKey];
        Ext.Router._lifecycleListeners = lifecycleListeners;
        return true;
      }
    }]);

    return ExtComp;
  }(React.Component);

  ExtComp.type = isView ? 'View' : 'Component';
  return ExtComp;
};

var register = function register(ExtClass, ExtClassName) {
  var finalClass = registerCallbacks.reduce(function (Class, fn) {
    var type = Class.WrappedComponent && Class.WrappedComponent.type || Class.type;
    return fn(Class, type == 'View', defaults.globalPlugins.concat(Class.plugins || []).filter(function (key, index, source) {
      return key && key[0] != '-' && source.indexOf("-".concat(key)) == -1 && source.indexOf(key) == index;
    }), ExtClassName) || Class;
  }, ExtClass);
  viewMap[ExtClassName] = finalClass;
  return finalClass;
};

var init = function init(rn) {
  var react = rn || React;

  if (react) {
    cache.View = createComponent(react, TRUE);
    cache.Component = createComponent(react, FALSE);
    initFns.forEach(function (fn) {
      return fn(react);
    });
  } else {
    console.error('[QRN-Ext Error]', 'Not Found React');
  }
};

var getCache = function getCache(name) {
  if (!cache[name]) {
    init();
  }

  return cache[name];
};

var defineStateProperty = function defineStateProperty(obj, attr, fn) {
  Object.defineProperty(obj, attr, {
    get: fn,
    set: _noop
  });
};

defineStateProperty(Ext, 'View', function () {
  return getCache('View');
});
defineStateProperty(Ext, 'Component', function () {
  return getCache('Component');
});
defineStateProperty(React, 'QView', function () {
  return getCache('View');
});
defineStateProperty(React, 'QComponent', function () {
  return getCache('Component');
});
defineStateProperty(global, 'QView', function () {
  return getCache('View');
});
defineStateProperty(global, 'QComponent', function () {
  return getCache('Component');
});
Ext.init = init;
/**
 * 添加插件函数
 * @param  {String}     name             插件名
 * @param  {Function}   adapter          适配函数
 * @param  {Function}   initFn           Ext 初始化回调函数
 * @param  {Function}   registerFn       View 注册回调函数
 */

Ext.addPlugin = function (name, adapter, initFn, registerFn) {
  if (_isString(name)) {
    plugins[name] = adapter;

    if (_isFunction(initFn)) {
      initFns.push(initFn);
    }

    if (_isFunction(registerFn)) {
      registerCallbacks.push(registerFn);
    }
  }
};

Ext.register = register;
Ext._registerCallbacks = registerCallbacks;
Ext.viewMap = viewMap;
Ext._cache = cache;
Ext.utils = {
  getType: getType,
  isObject: _isObject,
  isArray: _isArray,
  isString: _isString,
  isFunction: _isFunction,
  isNumber: _isNumber,
  isPlainObject: _isPlainObject,
  isEmptyObject: _isEmptyObject,
  noop: _noop,
  extend: _extend,
  createEventManager: _createEventManager,
  CustEvent: CustEvent,
  startWith: _startWith,
  endWith: _endWith,
  sliceFn: _sliceFn
};
global.Ext = Ext;
export default Ext;